import React from 'react';

export interface PlaceholderImageProps {
	/** Whether or not to display a spinner in the center of the placeholder. */
	showSpinner: boolean;
	name: string;
}

/**
 *  Renders placeholder image for hawksearch recommended product.
 */
export function PlaceholderImage({ showSpinner }: PlaceholderImageProps) {
	return (
		<div className="roc-product-list__image-placeholder">
			{showSpinner && <div className="roc-product-list__image-placeholder-image">Loading...</div>}
		</div>
	);
}
